/* Per-vertical Conversation Director config (Real Estate). The engine in
 * lib/roleplay/director.ts is generic; this tunes it for the buyer-rep roleplay.
 *
 * Real-estate personas are NOT time-boxed sales meetings — they're a buyer being
 * represented, and the "close" is demonstrating the rep SKILLS (needs assessment,
 * agency disclosure, material facts), not extracting a "yes, set up a meeting."
 * So most of the value here is the vertical-agnostic part of the Director:
 * anti-reset, noise-resilience, stall recovery, and the anti-loop on answered
 * objections. The commitment/scheduling directives stay quiet, and the time
 * directive is OFF (these personas shouldn't invent a countdown). */
import type { DirectorConfig } from '@/lib/roleplay/director';

export const DIRECTOR_CONFIG: DirectorConfig = {
  // RE "commit" milestones are skills; landing one advances the phase machine.
  commitTags: [
    'complete_structured_needs_assessment_covering_all_four_domains',
    'explain_agency_relationship_and_buyer_representation_agreement',
    'proactively_raise_material_fact_and_inspection_considerations',
    'commit_to_specific_communication_and_marketing_plan',
    'present_comparable_sales_data_for_accurate_pricing',
    'surface_full_budget_and_long_term_goals_before_recommending',
  ],

  // Generic "let's lock a next step" cue (a showing, a follow-up, sending docs).
  schedulingCue:
    /\b(next step|follow[- ]?up|schedule|set up a (showing|time|call|meeting)|when (are|works|can|could)|send (you|over)|put together)\b/i,

  // No high-weight credibility lever in the RE roleplay (unlike Comcast's CEO
  // referral). Left empty; add per scenario if one emerges.
  credibilityCues: [],

  // Not used while announceTimeRemaining is off, but the field is required.
  sessionSeconds: 15 * 60,

  // RE personas are not on a clock — don't nudge them to invent time pressure.
  announceTimeRemaining: false,
};
